import axios from "axios";
import { apiBase } from "./api-base.js";

// baseURL resolves from the page's hostname (see api-base.js): same bundle
// works in prod, dev, localhost, and the named tunnel with no hardcoded host.
axios.defaults.baseURL = apiBase();
axios.defaults.timeout = 600000;

export function createClient(token) {
  const instance = axios.create({
    headers: {
      token: token,
    },
  });

  //axiosRetry(instance, { retryDelay: axiosRetry.exponentialDelay });

  instance.interceptors.response.use((value) => {
    return value.data;
  });

  // Add streaming method for Server-Sent Events
  instance.postEventStream = async (url, data, options = {}) => {
    const baseURL = axios.defaults.baseURL.replace(/\/+$/, "");
    const fullUrl = baseURL + (url.startsWith("/") ? url : "/" + url);
    
    return fetch(fullUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "token": token,
        ...options.headers
      },
      body: JSON.stringify(data),
      signal: options.signal,
    });
  };

  return instance;
}
